/** Generates a random text string for use as unique labels. */
export const randomLabel = () =>
  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
